import { render, staticRenderFns } from "./IvyClientDetail.vue?vue&type=template&id=1ba21998&"
import script from "./IvyClientDetail.vue?vue&type=script&lang=js&"
export * from "./IvyClientDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports